import { createFileRoute, Link, useRouter } from "@tanstack/react-router";
import { withMemberGate } from "@/lib/with-member-gate";
import { Zap, ArrowLeft } from "lucide-react";
import { QuickResets } from "@/components/QuickResets";

export const Route = createFileRoute("/quick-resets")({
  head: () => ({
    meta: [
      { name: "robots", content: "noindex" },
      { title: "Quick Nervous System Resets — Recovery Trauma™" },
      {
        name: "description",
        content:
          "60-second somatic resets for the moments you need to settle quickly. Cold-water reset, physiological sigh, humming, butterfly hug, ear massage, orienting.",
      },
      { property: "og:title", content: "Quick Nervous System Resets — Recovery Trauma™" },
      { property: "og:description", content: "60-second somatic resets for the moments you need to settle quickly. Cold-water reset, physiological sigh, humming, butterfly hug, ear massage, orienting." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      { property: "og:url", content: "https://recoverytrauma.com/quick-resets" },
    ],
    links: [{ rel: "canonical", href: "https://recoverytrauma.com/quick-resets" }],
  }),
  component: withMemberGate(QuickResetsPage, "Quick Resets"),
});

function QuickResetsPage() {
  const router = useRouter();
  return (
    <div className="mx-auto max-w-4xl px-4 py-10">
      <header className="mb-6 text-center sm:mb-8">
        <div className="mb-3 inline-flex items-center gap-2 rounded-full border border-border bg-card px-3 py-1 text-[11px] text-muted-foreground">
          <Zap className="h-3.5 w-3.5" /> Quick Resets
        </div>
        <h1 className="font-display text-2xl tracking-tight text-foreground sm:text-4xl md:text-5xl">
          ⚡ Quick Nervous System Resets
        </h1>
        <p className="mx-auto mt-2 max-w-xl text-base leading-relaxed text-muted-foreground">
          Short, evidence-based interventions for the moments you need to settle fast.
          Pick one and begin — no reading required.
        </p>
      </header>

      <QuickResets />
    </div>
  );
}
